export const extractNameFromEmail = (email: string) => {
  if (!email) return;
  return email.split("@")[0];
};
// BTC to Sats converter
const btcToSats = (btc: number): number => Math.round(btc * 100000000);

// Main formatter - accepts BTC (string or number) and converts to sats first
export const formatIntoSats = (
  btcInput: string | number,
  decimals: number = 1,
): string => {
  // First convert to number
  const btc = typeof btcInput === "string" ? parseFloat(btcInput) : btcInput;

  if (isNaN(btc)) {
    return "Invalid BTC value";
  }

  // Convert BTC to sats
  const sats = btcToSats(btc);

  // Now format the sats
  if (sats < 10000) {
    return `${sats} sats`;
  }

  if (sats < 1000000) {
    return `${(sats / 1000).toFixed(decimals)}k sats`;
  }

  if (sats < 1000000000) {
    return `${(sats / 1000000).toFixed(decimals)}m sats`;
  }

  return `${(sats / 1000000000).toFixed(decimals)}b sats`;
};
